import { Handle, Position, NodeResizer } from "reactflow";
import { ChevronDown, ChevronRight, Group, Ungroup } from "lucide-react";

const HANDLE_STYLE = { width: 8, height: 8, background: "#475569", border: "1px solid white" };

export function ArchiGroupNode({ id, data, selected }) {
  const { element, onClick, collapsed, onToggleCollapse, onUngroup, onResizeEnd, minWidth = 220, minHeight = 140, readOnly } = data;

  return (
    <div
      data-testid={`archimate-group-${element.id}`}
      onClick={readOnly ? () => onClick(element.id) : undefined}
      onDoubleClick={readOnly ? undefined : () => onClick(element.id)}
      title={readOnly ? "Tap to view details" : "Double-click to view details"}
      className={`group relative h-full w-full rounded-lg border-2 border-dashed bg-slate-100/50 cursor-pointer ${
        selected ? "ring-2 ring-offset-1 ring-blue-500" : ""
      }`}
      style={{ borderColor: "#64748B" }}
    >
      <NodeResizer
        isVisible={selected && !collapsed && !readOnly}
        minWidth={minWidth}
        minHeight={minHeight}
        handleStyle={{ width: 8, height: 8, borderRadius: 2 }}
        onResizeEnd={(_e, params) => onResizeEnd(params.width, params.height)}
      />
      <Handle id="top" type="target" position={Position.Top} style={HANDLE_STYLE} />
      <Handle id="left" type="target" position={Position.Left} style={HANDLE_STYLE} />
      <Handle id="right" type="source" position={Position.Right} style={HANDLE_STYLE} />
      <Handle id="bottom" type="source" position={Position.Bottom} style={HANDLE_STYLE} />
      <div
        data-testid={`group-header-${id}`}
        className="nodrag flex items-center gap-1.5 px-2 py-1.5 rounded-t-lg border-b border-dashed cursor-pointer bg-slate-200/80 hover:bg-slate-200"
        style={{ borderColor: "#64748B" }}
        onClick={(e) => {
          e.stopPropagation();
          onToggleCollapse();
        }}
      >
        {collapsed ? <ChevronRight size={13} className="text-slate-600" /> : <ChevronDown size={13} className="text-slate-600" />}
        <Group size={12} className="text-slate-600" />
        <span className="text-[11px] font-bold uppercase tracking-wide text-slate-700 truncate flex-1">{element.name}</span>
        {!readOnly && (
          <button
            data-testid={`ungroup-button-${id}`}
            onClick={(e) => {
              e.stopPropagation();
              onUngroup();
            }}
            className="nodrag opacity-0 group-hover:opacity-100 transition-opacity text-slate-500 hover:text-slate-800"
            title="Ungroup"
          >
            <Ungroup size={12} />
          </button>
        )}
      </div>
    </div>
  );
}
